// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2vIIi","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2fani","obliqueLine":"membershipbadge_obliqueLine__1uuEV"};